module.exports = __webpack_public_path__ + "img/real-estate-login.d534823e.jpg";